import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppError } from 'app/classes/app-error';
import { includes } from 'lodash';
import * as moment from 'moment';
import { empty, forkJoin, Observable, throwError } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import { OfflineService } from './offline.service';
import { UserDatabaseService } from './user-database.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorInterceptorService implements HttpInterceptor {
  private _errorExpirationDays = 30;
  constructor(private offline: OfflineService, private database: UserDatabaseService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (req.url.toLowerCase().includes('auth/status') && error.status === 401) {
          return next.handle(req);
        }

        this._saveError(error).subscribe();
        return throwError(error);
      }),
    );
  }

  private _saveError(error: HttpErrorResponse, metadata?: any): Observable<void> {
    const objectStores = this.database.getObjectStoresNames();
    if (includes(objectStores, 'errors')) {
      return this.offline.save(
        AppError,
        new AppError({
          name: error.name,
          message: error.message,
          metadata: metadata,
          timestamp: moment(),
          status: error.status,
          statusText: error.statusText,
          url: error.url,
        }),
      ).pipe(concatMap(() => this._removeErrors()));
    } else {
      return empty();
    }
  }

  private _removeErrors(): Observable<void> {
    const day = moment().add(-this._errorExpirationDays, 'days');
    return this.offline.getAll(AppError).pipe(
      concatMap((errors: AppError[]) => {
        const errorsToDelete = errors.filter(error => moment(error.timestamp).isBefore(day));
        if (errorsToDelete && errorsToDelete.length > 0) {
          const deleteObs = errorsToDelete.map(error => this.offline.delete(AppError, error));
          return forkJoin(...deleteObs);
        } else {
          return empty();
        }
      }),
    );
  }
}
